// prettier-ignore
export const cpfCnpj = {
  cpf: [
    /\d/,/\d/,/\d/,
    '.',/\d/,/\d/,/\d/,
    '.',/\d/,/\d/,/\d/,
    '-',/\d/,/\d/,
  ],
  cnpj: [
    /\d/,/\d/,
    '.',/\d/,/\d/,/\d/,
    '.',/\d/,/\d/,/\d/,
    '/',/\d/,/\d/,/\d/,/\d/,
    '-',/\d/,/\d/,
  ],
}

// prettier-ignore
export const phone = {
  phone8: [
    '(', /\d/, /\d/, ')', ' ',
    /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/
  ],
  phone9: [
    '(', /\d/, /\d/, ')', ' ',
    /\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/
  ],
}

export const maskCpf = (cpf) => {
  if (!cpf) return
  const onlyNumbers = cpf.replace(/\D/g, '')
  return onlyNumbers.replace(/^(\d{3})(\d{3})(\d{3})(\d{2}).*/, '$1.$2.$3-$4')
}

export const maskCnpj = (cnpj) => {
  if (!cnpj) return
  const onlyNumbers = cnpj.replace(/\D/g, '')
  return onlyNumbers.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/, '$1.$2.$3/$4-$5')
}

export const maskPhone = (phone) => {
  if (!phone) return
  if (phone.length <= 10) return phone.replace(/^(\d{2})(\d{4})(\d{4}).*/, '($1) $2 $3')
  return phone.replace(/^(\d{2})(\d{1})(\d{4})(\d{4}).*/, '($1) $2 $3 $4')
}
